export default __webpack_public_path__ + "static/media/IMG_4542-min.601af9e5.JPG";